import { Component } from '@angular/core';
import { ViewController } from 'ionic-angular';
import { Keyboard } from '@ionic-native/keyboard/ngx';

import * as $ from 'jquery';

@Component({
   selector: 'page-usage',
   templateUrl: 'usage.html'
})

export class UsagePage
{

   private active = [ false, false, false, false, false, false, false, false, false, false ];


   /** ----- Constructor ----- **/

   constructor( private viewCtrl: ViewController,
                private keyboard: Keyboard )
   {

      this.keyboard.disableScroll( true );

   }


   /** ----- UI Callback ----- **/

   onBackClicked()
   {

      this.viewCtrl.dismiss();

   }


   onItemClicked( inIdx )
   {

      this.active[ inIdx ] = !this.active[ inIdx ];

   }


   checkBlur()
   {

      $( '.usage-left-top-padding' ).show();

   }


   checkFocus()
   {

      $( '.usage-left-top-padding' ).hide();

   }

}



// WEBPACK FOOTER //
// ./src/pages/usage/usage.ts